<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <span>Importação de destinatários</span>
    </div>
    <div>
      <ImportDelivery />
    </div>
  </el-card>
</template>

<script>
import ImportDelivery from './ImportDelivery';

export default {
  name: 'ImportDeliveryUpload',
  components: {
    ImportDelivery,
  },
};
</script>
